import { Share2, FileText, Download } from "lucide-react";
import BackHeader from "../components/BackHeader";
import { Icons } from "../assets/icons/Icons";

export default function TransactionDetails({ transaction }) {
    const transactionData = transaction || {
        id: "1",
        type: "Deposit",
        description: "From Crypto",
        amount: 2500.95,
        date: "April 14, 2021",
        time: "09:15",
        reference: "REF-85721",
        status: "Completed",
    };

    const isNegative = transactionData.amount < 0;
    const isNeutral = transactionData.type === "plan_activation";
    const formattedAmount = `$${Math.abs(transactionData.amount).toFixed(2)}`;

    let amountColor = "amount-success";
    let prefix = "+ ";

    if (isNegative) {
        amountColor = "amount-danger";
        prefix = "- ";
    } else if (isNeutral) {
        amountColor = "amount-info";
        prefix = "= ";
    }

    return (
        <div
            className="min-vh-100 d-flex flex-column"
            style={{
                padding: "20px",
            }}
        >
            {/* Header */}

            <BackHeader title="Transaction" />

            {/* Main Card */}
            <div
                className="card border-0 mb-4 text-center p-4"
                style={{
                    backgroundImage: `url("images/store/transaction_detail_card_bg.png")`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    overflow: "hidden",
                }}
            >
                <h2 className="text-white" style={{ fontSize: "24px" }}>
                    Transition Details
                </h2>

                {/* Transaction Icon */}
                <div className="d-flex justify-content-center mt-3">
                    {getIconComponent(transactionData.type.toLowerCase())}
                </div>

                {/* Transaction Type */}
                <h3 className="text-white mb-1" style={{ fontSize: "24px" }}>
                    {transactionData.type}
                </h3>
                <p className="font-15 mb-1">{transactionData.description}</p>

                {/* Amount */}
                <h2
                    className={` ${amountColor} mb-3`}
                    style={{ fontSize: "40px" }}
                >
                    {prefix}
                    {formattedAmount}
                </h2>

                {/* Status */}
                <div className="d-flex justify-content-center mb-2">
                    <div
                        className="px-4 py-2 rounded-pill"
                        style={{ backgroundColor: "#1E1E1E" }}
                    >
                        <span className="text-white">
                            {transactionData.status}
                        </span>
                    </div>
                </div>

                {/* Action Buttons */}
            </div>

            <div className="d-flex justify-content-around mt-4">
                <div className="d-flex flex-column align-items-center">
                    <div
                        className="d-flex justify-content-center align-items-center rounded-circle mb-2"
                        style={{
                            width: "56px",
                            height: "56px",
                            backgroundColor: "#1E1E1E",
                        }}
                    >
                        <Download className="text-white" size={24} />
                    </div>
                    <span className="text-white" style={{ fontSize: "15px" }}>
                        Receipt
                    </span>
                </div>

                <div className="d-flex flex-column align-items-center">
                    <div
                        className="d-flex justify-content-center align-items-center rounded-circle mb-2"
                        style={{
                            width: "56px",
                            height: "56px",
                            backgroundColor: "#1E1E1E",
                        }}
                    >
                        <Share2 className="text-white" size={24} />
                    </div>
                    <span className="text-white" style={{ fontSize: "15px" }}>
                        Share
                    </span>
                </div>

                <div className="d-flex flex-column align-items-center">
                    <div
                        className="d-flex justify-content-center align-items-center rounded-circle mb-2"
                        style={{
                            width: "56px",
                            height: "56px",
                            backgroundColor: "#1E1E1E",
                        }}
                    >
                        <FileText className="text-white" size={24} />
                    </div>
                    <span className="text-white" style={{ fontSize: "15px" }}>
                        Report
                    </span>
                </div>
            </div>

            {/* Details Section */}
            <div className="mt-4">
                <h3 className="text-white fs-2 mb-4">Details</h3>

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                        <div
                            className="d-flex justify-content-center align-items-center me-3"
                            style={{ width: "24px" }}
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M16 2V6"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M8 2V6"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M3 10H21"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <span className="font-15">Date</span>
                    </div>
                    <span className="text-white">{transactionData.date}</span>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                        <div
                            className="d-flex justify-content-center align-items-center me-3"
                            style={{ width: "24px" }}
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M12 6V12L16 14"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <span className="" style={{ fontSize: "15px" }}>
                            Time
                        </span>
                    </div>
                    <span className="text-white" style={{ fontSize: "15px" }}>
                        {transactionData.time}
                    </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                        <div
                            className="d-flex justify-content-center align-items-center me-3"
                            style={{ width: "24px" }}
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M14 2V8H20"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M16 13H8"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M16 17H8"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M10 9H9H8"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <span className="font-15">Reference</span>
                    </div>
                    <span className="text-white">
                        {transactionData.reference}
                    </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                        <div
                            className="d-flex justify-content-center align-items-center me-3"
                            style={{ width: "24px" }}
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 1V23"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
                                    stroke="#6C757D"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <span className="font-15">Amount</span>
                    </div>
                    <span className={` ${amountColor} mb-3`}>
                        {prefix}${transactionData.amount.toFixed(2)}
                    </span>
                </div>
            </div>
        </div>
    );
}

function getIconComponent(iconName) {
    switch (iconName) {
        case "withdraw":
            return <Icons.Withdraw fill="#2E2CB2" />;
        case "deposit":
            return <Icons.Deposit fill="#2E2CB2" />;
        case "exchange":
            return <Icons.Exchange fill="#2E2CB2" />;
        case "plan_activation":
            return <Icons.Plan fill="#2E2CB2" />;
        default:
            return <Icons.Withdraw fill="#2E2CB2" />;
    }
}
